/* @flow */

export const TODAY = 'TODAY';
export const PAST = 'PAST';
export const TOMORROW = 'TOMORROW';
export const FUTURE = 'FUTURE';
